import React from "react";
import { ReactComponent as PennyIcon } from "@assets/icons/penny_icon.svg";
import { getUsername } from "@utils/utilities";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "@utils/firebase";
import { useGetUser } from "@utils/hooks";

type WelcomePennyProps = {};

const WelcomePenny: React.FC<WelcomePennyProps> = () => {
  const { data } = useGetUser();
  const [user] = useAuthState(auth);
  const name = getUsername(user, data, true);

  return (
    <div className="px-4 bg-pn_paper-1 py-4 lg:px-[80px] md:pt-8 md:pb-10 flex flex-col gap-y-4 md:gap-y-0 md:flex-row items-center md:gap-x-4 justify-between">
      <div className="flex flex-col gap-y-4 md:gap-y-2.5 max-w-[650px] w-full">
        <span className="text-pn-large-title">Welcome to Penny,<br className="md:hidden" /> {name}!</span>
        <span className="text-pn-body-large-regular text-pn_gray-600">
          It's great having you here! As one of our first members, you are
          eligible to enroll in our Penny Private Club. Once you complete your
          pension application, we will tell you more about the benefits.
        </span>
      </div>

      <div className="max-w-full bg-white md:bg-transparent p-6 md:p-0 md:max-w-[295px] w-full border md:border-none border-pn_gray-200 rounded-2xl md:rounded-none">
        <div className="rounded-lg w-full justify-between gradient-card h-[166px] shadow-pn-large pt-3 pl-3 pb-[15px] pr-[16.63px] flex flex-col">
          <div className="flex flex-col gap-y-1">
            <span className="text-pn-caption-1-medium">Early Member Club</span>
            <span className="text-pn-title-regular">{name}</span>
          </div>

          <div className="flex items-end justify-between isolate">
            <span className="text-pn-body-large-regular uppercase">
              #{user?.uid.slice(0, 5)}
            </span>
            <PennyIcon
              width={47}
              height={52}
              className="-z-10 [&>path]:fill-[#464646]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default WelcomePenny;
